import React, { useEffect, useState } from 'react';
import './SponsorshipDetail.css';
import { useNavigate, useParams } from 'react-router-dom';
import backIcon from '../../assets/backspace-icon.png';
import api from '../../api';

function SponsorshipDetail() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [sponsorship, setSponsorship] = useState(null);
  const [loading, setLoading] = useState(true);
  const [countdown, setCountdown] = useState('');

  useEffect(() => {
    const fetchSponsorship = async () => {
      try {
        const res = await api.get(`/sponsorships/detail/${id}`);
        setSponsorship(res.data);
      } catch (err) {
        console.error('❌ Failed to fetch sponsorship details:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchSponsorship();
  }, [id]);

  useEffect(() => {
    if (sponsorship?.sponsorshipStatus === 'approved' && sponsorship?.sponsorshipExpiresAt) {
      const interval = setInterval(() => {
        const now = new Date();
        const expires = new Date(sponsorship.sponsorshipExpiresAt);
        const diff = expires - now;

        if (diff <= 0) {
          setCountdown('⏳ Expired');
          clearInterval(interval);
        } else {
          const days = Math.floor(diff / (1000 * 60 * 60 * 24));
          const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
          const minutes = Math.floor((diff / (1000 * 60)) % 60);
          setCountdown(`${days}d ${hours}h ${minutes}m remaining`);
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [sponsorship]);

  const handleDecision = async (status) => {
    try {
      await api.post(`/sponsorships/update-status`, {
        productId: id,
        status,
      });
      alert(`✅ Sponsorship ${status}`);
      navigate(-1);
    } catch (err) {
      alert(err.response?.data?.message || '❌ Failed to submit decision');
    }
  };

  if (loading) return <div className="sponsorshipdetail-loading">Loading...</div>;
  if (!sponsorship) return <div className="sponsorshipdetail-error">Sponsorship not found.</div>;

const {
  username,
  businessUsername,
  businessName,
  sponsorshipStatus,
  sponsorshipSubmittedAt,
  sponsorshipExpiresAt,
  product
} = sponsorship;



  return (
    <div className="sponsorshipdetail-container">
      <div className="sponsorshipdetail-topbar">
        <img
          src={backIcon}
          alt="Back"
          className="sponsorshipdetail-back-icon"
          onClick={() => navigate(-1)}
        />
        <h2 className="sponsorshipdetail-header">Sponsorship Review</h2>
      </div>

      <div className="sponsorshipdetail-scroll-area">

<h3>{businessName || 'Unnamed Business'}</h3>
<p><strong>Business Username:</strong> @{businessUsername || username}</p>

        <p>
          <strong>Status:</strong> {sponsorshipStatus}
          {sponsorshipStatus === 'approved' && !sponsorshipExpiresAt && (
            <span className="waiting-payment-label"> (waiting for payment)</span>
          )}
        </p>

        <p><strong>Applied:</strong> {new Date(sponsorshipSubmittedAt).toLocaleDateString()}</p>

        {sponsorshipStatus === 'approved' && sponsorshipExpiresAt && (
          <p className="countdown-timer">⏳ {countdown}</p>
        )}

        <div className="sponsorshipdetail-preview">
          <h4>Product Preview:</h4>
          <div className="sponsorshipdetail-product-card">
            <img
              src={product?.media?.[0] || 'https://via.placeholder.com/150'}
              alt={product?.name}
              className="sponsorshipdetail-product-image"
            />
            <div className="sponsorshipdetail-product-info">
              <p><strong>{product?.name}</strong></p>
              <p>{product?.description}</p>
              <p>
                Price:{' '}
                {product?.pricingType === 'dynamic'
                  ? `${product?.usdPrice} USD`
                  : `${product?.price} Pi`}
              </p>
            </div>
          </div>
        </div>

        <div className="sponsorshipdetail-actions">
          {sponsorshipStatus === 'pending' && (
            <>
              <button className="approve-btn" onClick={() => handleDecision('approved')}>
                Approve
              </button>
              <button className="reject-btn" onClick={() => handleDecision('rejected')}>
                Reject
              </button>
            </>
          )}
          {sponsorshipStatus === 'approved' && (
            <button className="reject-btn" onClick={() => handleDecision('rejected')}>
              ⛔ Stop
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default SponsorshipDetail;
